<template id="personal_center">
	<div>
		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage" v-show="!showDetail">
				<p class="account_manage_title">You have <span class="text-primary">{{total}}</span> comments</p>

				<div class="nano video_breviary">
					<div class="nano-content" id="home_left_list">
						<ul class="p-0 pl-4 pr-4">
							<li v-for="item in list" @click='gotoDetail(item.content_id)' class="pt-4 pb-4 w-100 d-inline-block border-bottom border-top-0 border-right-0 border-left-0">
								<div>
									<img :src="item.passport.img_url" v-if="item.passport.img_url" class="rounded-circle img-fluid" style="width: 40px; height: 40px;" />
									<span class="f15 ml-2">{{item.passport.nickname}}</span>
									<span class="f12 text-black-50 ml-4">{{timeDiff(item.create_time)}}</span>
								</div>
								<div class="mt-3 ml-5">
									<p class="comment_abstract mb-3">
										{{item.content}}
									</p>
									<p class="bg-light p-3">
										<img :src="item.thumb" v-if="item.thumb" class="img-fluid" style="width: 60px; height: 48px;" />
										<span class="f14 text-black-50 ml-2">{{item.title}}</span>
									</p>
								</div>
							</li>
						</ul>
                        <div v-if="list.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                            <p class="text-center p-2">loading</p>
                        </div>
					</div>
				</div>
			</div>
            <div class="accountManage" v-show="showDetail">
                    <span class="myBtn" @click='goback()'>Back</span>
                <div class="centre_content nano" id="centre_contents">
                        <span class="nano-content p-4" >
                                    <h1 class="information_article_headline">{{product.title}}</h1>
                                    <p class="information_article_info">
                                    <span class="mr-2">{{product.published}}</span>
                                    <span v-if="product.author && product.author.length > 0">Author：<span class="mr-2" v-for="(value,index) in product.author">{{value}}</span>
                                                                </span>
                                    <span v-if="product.source">Sources：{{product.source}}</span>
                                    </p>
                                    <div class="information_article_abstract rounded">
                                    <p>
                                        Abstract：{{product.description}}
                                    </p>
                                    </div>
                            <!-- 文章 -->
                            <div class="information_article_details text-indent2" v-if="product.appid == 1" v-html="product.content"></div>
                            <!-- 组图 -->
                            <div class="information_article_details text-indent2" v-if="product.appid == 2">
                                    <div v-for="item in JSON.parse(product.content)">
                                        <p>
                                            <img class="img-thumbnail" :src="item.url"/>
                                        </p>
                                        <p v-html="item.description"></p>
                                    </div>
                                    </div>
                            <!-- 视频 -->
                            <div class="information_article_details text-indent2" v-if="product.appid == 4">
                                    <video id="my-video" class="video-js" controls preload="auto" style="width: 100%;" height="400" :poster="product.content" data-setup="{}">
                                    <source ref="video" type="video/mp4">
                                        <!--<p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that
                                        <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
                                        </p>-->
                                    </video>
                                    </div>
                                    <span class="f12 d-block mb-2" v-if="product.editor">Editor：{{product.editor}}</span>
                                    </span>
                </div>
            </div>
		</div>
	</div>
</template>
<script>
	export default({
		name: 'myComment',
		data: function() {
			return {
                current_page : 1,
                page_size : 10,
                total_page : 1,
                total: 0,
                list: [],
                product: {},
                showDetail: false
			}
		},
		created: function() {
			var self = this;
            this.$axios.post('/api/pc/commentmy',{page:self.current_page, pagesize: self.page_size}).then(data => {
                if (data.data.state) {
                    self.list=data.data.data.data;
                    self.total = data.data.data.cmt_sum;
                    self.total_page=Math.ceil(data.data.data.cmt_sum/self.page_size);
                }
            })
		},
		mounted() {
            document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
            this.load();
		},
		methods: {
            gotoDetail(id){
                var that = this;
                this.$axios.post('/api/pc/getarticledetail', {
                    id: id
                }).then(response => {
                    if(response.data.state) {
                        that.showDetail=true;
                        that.product = response.data.data;
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })
            },
            goback(){
                this.showDetail=false;
            },
            Scrolles() {
                let that = this;
                var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_left_list').scrollHeight; // 总高度
                if ((all - 20) < (top + client)) {
                    this.current_page++;
                    if (this.current_page > this.total_page) {
                        return;
                    }
                    this.$axios.post('/api/pc/commentmy', {
                        page: that.current_page,
                        pagesize:that.page_size
                    }).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.data.data;
                            JSON.stringify(homeListes);
                            var new_homeLists = that.list.concat(homeListes);
                            that.list = new_homeLists;
                        }
                    })
                }
            },
            timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - (published * 1000);
                //计算出相差年
                var year = Math.floor(date3 / (12 * 30 * 24 * 3600 * 1000))
                //计算出相差月
                var month = Math.floor(date3 / (30 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))

                if (years > 0) {
                    if(years==1){
                        return years + 'year ago';
                    }
                    return years + 'years ago';
                }

                if(mouths > 0) {
                    if(mouths==1){
                        return mouths + 'month ago';
                    }
                    return mouths + 'months ago';
                }

                if (days > 0) {
                    if(days==1){
                        return days + 'day ago';
                    }
                    return days + 'days ago';
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
            },
		}

	})
</script>
<style scoped>
    .nano-content li:hover{
        cursor:pointer;
    }
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        z-index:100;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
</style>
